import React from 'react';
import EventForm from 'forms/EventForm';

export default (): JSX.Element => <EventForm />;
